<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/audio']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'audio_common_name' | translate"></nz-statistic>
    </a>
</nz-card>